import { render, staticRenderFns } from "./findpassword.vue?vue&type=template&id=796b485e&scoped=true&"
import script from "./findpassword.vue?vue&type=script&lang=js&"
export * from "./findpassword.vue?vue&type=script&lang=js&"
import style0 from "./findpassword.vue?vue&type=style&index=0&id=796b485e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b485e",
  null
  
)

export default component.exports